import AppEvents from 'Shared/app-events';

class QuantityInputModel {
    constructor(params, componentInfo) {
        let defaults = {
            groupCss: '',
            buttonsCss: '',
            buttonDecreaseCss: 'rounded-start-pill',
            iconDecrease: 'minus',
            buttonIncreaseCss: 'rounded-end-pill',
            iconIncrease: 'add',
            buttons: true
        };

        this.#data = ko.unwrap(params.data);

        this._value = params.value || ko.observable();

        this.value.subscribe(() => {
            AppEvents.emit("Store.QuantitySelected", this);
        });

        this.unit = ko.pureComputed(() => ko.unwrap(params.unit));

        this.default = ko.pureComputed(() => ko.unwrap(params.def) || ko.unwrap(params.min) || ko.unwrap(params.step) || 1);

        this.min = ko.pureComputed(() => ko.unwrap(params.min) || ko.unwrap(params.step));

        this.max = ko.pureComputed(() => ko.unwrap(params.max));

        this.step = ko.pureComputed(() => ko.unwrap(params.step) || 1);
        
        this.buttons = ko.pureComputed(() => ko.unwrap(params.buttons ?? true));
        this.decimals = ko.pureComputed(() => ko.unwrap(params.decimals) || 3);


        this.formatter = new Intl.NumberFormat(requireOptions.globalOptions.uiCulture, {
            minimumFractionDigits: 0,
            maximumFractionDigits: this.decimals()
        });


        this.#thousandSeparator = this.formatter.format(11111).replace(/1/g, '') || '.';
        this.#decimalSeparator = this.formatter.format(1.1).replace(/1/g, '');

        this.options = Object.assign({}, params.options, defaults);
    }

    
    #thousandSeparator = ',';
    #decimalSeparator = '.';
    #data = {};

    unit = ko.observable();
    default = ko.observable();
    min = ko.observable();
    max = ko.observable();
    step = ko.observable();
    buttons = ko.observable();

    spinnerCss = ko.pureComputed(() => {
        var classes = [];

        if (this.value()) {
            classes.push("input-active");
        }

        return classes.join(' ');
    });

    inputCss = ko.pureComputed(() => {
        var classes = [];

        classes.push(this.buttons() ? "px-4" : "px-1");

        return classes.join(' ');
    });

    value = ko.pureComputed({
        read: () => {
            if (this._value()) {
                return this.formatter.format(this._value());
            }

            return '';
        },
        write: (newValue) => {
            if (newValue == undefined || newValue === '') {
                this._value(null);
            } else {
                newValue = newValue.replace(new RegExp(' ', 'g'), '');

                if (this.#thousandSeparator != '') {
                    newValue = newValue.replace(new RegExp('\\' + this.#thousandSeparator, 'g'), '');
                }

                if (this.#decimalSeparator != '') {
                    newValue = newValue.replace(new RegExp('\\' + this.#decimalSeparator), '.');
                }

                let value = parseFloat(newValue);

                if (isNaN(value) || value <= 0) {
                    value = null;
                } else if (this.step() && value % this.step() != 0) {
                    value = Math.ceil(value / this.step()) * this.step();
                }

                
                if (value && this.min() && value < this.min()) {
                    this._value(this.min());
                } else if (value && this.max() && value > this.max()) {
                    this._value(this.max());
                } else {
                    this._value(value);
                }
            }

            //this._value.valueHasMutated();
        }
    }).extend({ notify: 'always' });

    ph = ko.pureComputed(() => {
        let value = this.default() > 0 ? this.default()
            : this.min() > 0 ? this.min()
                : this.step() > 0 ? this.step() : 1;
        let ph = this.formatter.format(value);
        if (this.unit()) {
            ph += " " + this.unit();
        }

        return ph;
    });

    unit = ko.observable();

    #updateValue = (value, step) => {
        value = value + step;

        if (value != this.default() && value >= (this.min() || this.step())) {
            this._value(value);
        } else {
            this._value(null);
        }
    }

    cursor = (model, e) => {
        switch (e.keyCode) {
            case 38: //"ArrowUp
            case 39: //"ArrowRight"
                this.increase();
                break;
            case 40: //"ArrowDown"
            case 37: //"ArrowLeft"
                this.decrease();
                break;
            default:
                return true;
        }
    }

    increase = (model, e) => {
        const value = this._value() || this.default() || this.min() || this.step(),
            step = this.step();

        this.#updateValue(value, step);
    }

    canIncrease = ko.pureComputed(() => {
        const value = this._value() || this.default();

        return !this.max() || this.max() && this.max() >= (value + this.step());
    });

    decrease = (model, e) => {
        const value = this._value() || this.default() || this.max(),
            step = this.step();

        this.#updateValue(value, -step);
    }

    canDecrease = ko.pureComputed(() => {
        const value = this._value() || this.default();
        
        return !this.min() && ((value - this.step()) > 0) || this.min() && this.min() <= (value - this.step());
    });

    clear = () => {
        this._value(null);
    }

    data = () => {
        return Object.assign({
            Quantity: this._value(),
        }, this.#data);
    }
}

ko.components.register('spinner', {
    viewModel: {
        createViewModel: (params, componentInfo) => new QuantityInputModel(params, componentInfo)
    },
    template: '<div class="input-group-merge input-group-sm qty-spinner" data-bind="css: spinnerCss">\
        <!-- ko if: buttons -->\
        <div class="input-group-prepend input-group-button">\
            <button type="button" class="btn btn-sm btn-ghost-primary btn-icon rounded-start-pill" data-bind="click: decrease, visible: canDecrease">\
                <svg class="svg-icon">\
                    <use xlink:href="#minus"></use>\
                </svg>\
            </button>\
        </div>\
        <!-- /ko -->\
        <input type="text" class="form-control text-center rounded-pill" data-bind="value: value, attr: { placeholder: ph }, css: inputCss, event: { keydown: cursor }" />\
        <!-- ko if: buttons -->\
        <div class= "input-group-append input-group-button" >\
            <button type="button" class="btn btn-sm btn-ghost-primary btn-icon rounded-end-pill" data-bind="click: increase, visible: canIncrease">\
                <svg class="svg-icon">\
                    <use xlink:href="#add"></use>\
                </svg>\
            </button>\
        </div>\
        <!-- /ko -->\
    </div>'
});